export default [
  [
    {
      id: 'id',
      label: 'รหัส',
      span: 4,
      type: 0,
      props: { disabled: true, padding: '8px 0', title: { text: 'รหัส' } },
    }, {
      id: 'name',
      label: 'ชื่อบริษัท',
      span: 16,
      type: 0,
      props: { padding: '8px 0', title: { text: 'ชื่อบริษัท *' } },
    }, {
      id: 'branch',
      label: 'สาขา',
      span: 4,
      type: 0,
      props: { padding: '8px 0', title: { text: 'สาขา' } },
    }, {
      id: 'taxId',
      label: 'เลขเสียภาษี',
      span: 4,
      type: 0,
      props: { padding: '8px 0', title: { text: 'เลขเสียภาษี' } },
    }, {
      id: 'address',
      label: 'ที่อยู่',
      span: 20,
      type: 0,
      props: { padding: '8px 0', title: { text: 'ที่อยู่' } },
    },
  ], [
    {
      label: 'หมายเหตุ',
      id: 'remark',
      span: 12,
      type: 1,
      props: { rows: 4 },
    },
  ],
]
